import React from 'react';
import { User } from 'lucide-react';

const ProfileImage = ({ 
  profilePicture, 
  name, 
  size = 'md', 
  className = '',
  showFallback = true 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-16 h-16 text-lg',
    xl: 'w-20 h-20 text-xl'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-8 h-8',
    xl: 'w-10 h-10'
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  // Support both new Firebase URL and legacy base64
  const picSrc = profilePicture?.url ||
    (profilePicture?.data ? `data:${profilePicture.contentType || 'image/jpeg'};base64,${profilePicture.data}` : null);

  if (picSrc) {
    return (
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden flex-shrink-0 ${className}`}>
        <img
          src={picSrc}
          alt={name || 'Profile'}
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  if (showFallback) {
    return (
      <div className={`${sizeClasses[size]} rounded-full bg-[#1086a4] text-white flex items-center justify-center font-semibold flex-shrink-0 ${className}`}>
        {name ? getInitials(name) : <User className={iconSizes[size]} />}
      </div>
    );
  }

  return null;
};

export default ProfileImage;
